import { render, staticRenderFns } from "./PackageHistory.vue?vue&type=template&id=43baf416&scoped=true&lang=pug&"
import script from "./PackageHistory.vue?vue&type=script&lang=js&"
export * from "./PackageHistory.vue?vue&type=script&lang=js&"
import style0 from "./PackageHistory.vue?vue&type=style&index=0&id=43baf416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43baf416",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VBtn,VContainer,VDataTable,VDivider,VIcon,VProgressCircular,VSpacer})
